module.exports = __webpack_public_path__ + "img/download-on-the-app-store-sv.248a52c5.svg";